/* Label Naveli — wishlist (saved in the visitor's browser) */
(function () {
  'use strict';
  var KEY = 'nv-wishlist';
  var PAGE = '/pages/wishlist';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.4C1.6 8 3.6 4.5 7.1 4.5c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.5 0 5.5 3.5 4.4 6.6-1.8 4.8-9.3 9.4-9.3 9.4z"/></svg>';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('nv:wishlist', { detail: list }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(added) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'nv-wtoast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = added
      ? '<span>Added to your wishlist</span><a href="' + PAGE + '">View</a>'
      : '<span>Removed from your wishlist</span>';
    toastEl.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-open'); }, 2600);
  }

  /* ---------- buttons ---------- */
  function paint(btn) {
    var on = has(btn.getAttribute('data-nv-wish'));
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.querySelector('.nv-wbtn__label');
    var text = on ? 'Saved to wishlist' : 'Add to wishlist';
    if (label && label.textContent !== text) label.textContent = text;
    if (btn.classList.contains('nv-wheart')) btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
  }
  function paintAll() {
    document.querySelectorAll('[data-nv-wish]').forEach(paint);
    var n = read().length;
    document.querySelectorAll('[data-nv-wish-count]').forEach(function (el) {
      if (el.textContent !== String(n)) el.textContent = n;
      el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nv-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(btn.getAttribute('data-nv-wish'));
    btn.classList.remove('is-pop'); void btn.offsetWidth; if (added) btn.classList.add('is-pop');
    toast(added);
  }, true);

  /* Hearts on product cards */
  function handleFromCard(card) {
    var payload = card.getAttribute('view-event-payload');
    if (payload) { try { var h = JSON.parse(payload).product.handle; if (h) return h; } catch (e) {} }
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function decorateCards(root) {
    (root || document).querySelectorAll('product-card').forEach(function (card) {
      if (card.querySelector('.nv-wheart')) return;
      var handle = handleFromCard(card);
      var gallery = card.querySelector('.card-gallery');
      if (!handle || !gallery) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nv-wheart';
      b.setAttribute('data-nv-wish', handle);
      b.innerHTML = HEART;
      gallery.appendChild(b);
      paint(b);
    });
  }

  /* Button on the product page */
  function decorateProduct() {
    var form = document.querySelector('product-form-component[data-product-url]');
    if (!form || document.querySelector('.nv-wbtn')) return;
    var m = form.getAttribute('data-product-url').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var anchor = form.closest('.buy-buttons-block') || form;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'nv-wbtn';
    b.setAttribute('data-nv-wish', m[1]);
    b.innerHTML = HEART + '<span class="nv-wbtn__label">Add to wishlist</span>';
    anchor.insertAdjacentElement('afterend', b);
    paint(b);
  }

  /* Heart with count in the header */
  function decorateHeader() {
    document.querySelectorAll('header-actions').forEach(function (actions) {
      if (actions.querySelector('.nv-whead')) return;
      var a = document.createElement('a');
      a.href = PAGE;
      a.className = 'nv-whead header-actions__action';
      a.setAttribute('aria-label', 'Wishlist');
      a.innerHTML = HEART + '<span class="nv-whead__count" data-nv-wish-count hidden>0</span>';
      var cart = actions.querySelector('[aria-controls="cart-drawer"], cart-icon');
      var before = cart ? (cart.closest('button, a') || cart) : null;
      if (before && before.parentElement === actions) actions.insertBefore(a, before); else actions.appendChild(a);
    });
  }

  /* ---------- wishlist page ---------- */
  var money = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function renderPage() {
    var root = document.querySelector('[data-nv-wishlist]');
    if (!root) return;
    var grid = root.querySelector('[data-nv-wishlist-grid]');
    var empty = root.querySelector('[data-nv-wishlist-empty]');
    var countEl = root.querySelector('[data-nv-wishlist-total]');
    var list = read();
    if (countEl) countEl.textContent = list.length ? (list.length + (list.length === 1 ? ' piece saved' : ' pieces saved')) : '';
    if (!list.length) { grid.innerHTML = ''; grid.hidden = true; empty.hidden = false; return; }
    empty.hidden = true; grid.hidden = false;
    grid.setAttribute('aria-busy', 'true');
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      var missing = [];
      products.forEach(function (p, i) {
        if (!p) { missing.push(list[i]); return; }
        var compare = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money.format(p.compare_at_price / 100) + '</s>' : '';
        html += '<li class="nv-wcard">' +
          '<a class="nv-wcard__media" href="' + esc(p.url) + '">' +
            (p.featured_image ? '<img src="' + esc(img(p.featured_image, 600)) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="800">' : '') +
            (p.available ? '' : '<span class="nv-wcard__sold">Sold out</span>') +
          '</a>' +
          '<button type="button" class="nv-wheart is-active" data-nv-wish="' + esc(p.handle) + '" aria-label="Remove from wishlist">' + HEART + '</button>' +
          '<div class="nv-wcard__info">' +
            '<a class="nv-wcard__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<p class="nv-wcard__price">' + compare + '<span>' + money.format(p.price / 100) + '</span></p>' +
            '<a class="nv-wcard__cta" href="' + esc(p.url) + '">' + (p.available ? 'Choose size &amp; buy' : 'View details') + '</a>' +
          '</div>' +
        '</li>';
      });
      if (missing.length) write(read().filter(function (h) { return missing.indexOf(h) === -1; }));
      grid.innerHTML = html;
      grid.removeAttribute('aria-busy');
      if (!html) { grid.hidden = true; empty.hidden = false; }
    });
  }

  document.addEventListener('nv:wishlist', function () {
    paintAll();
    if (document.querySelector('[data-nv-wishlist]')) renderPage();
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { paintAll(); renderPage(); } });

  function init() {
    decorateHeader();
    decorateCards();
    decorateProduct();
    paintAll();
    renderPage();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; decorateCards(); decorateProduct(); decorateHeader(); paintAll(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
